import React from "react";
import { Card, Container } from "react-bootstrap";
import { motion } from "framer-motion";

function ServicesCard() {
  return (
    <Container className="d-flex justify-content-center">
      <motion.div 
        initial={{ opacity: 0, y: 50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.6 }}
      >
        <Card className="text-white bg-dark p-2 rounded-3" style={{ maxWidth: "100%" }}>
          <Card.Body>
            <motion.h2 
              className="text-center fw-bold fs-1 mb-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              My Services
            </motion.h2>
            <motion.ul 
              className="list-unstyled text-white fs-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            >
              <motion.li whileHover={{ scale: 1.1 }}>✅ Private and Group Lessons</motion.li>
              <motion.li whileHover={{ scale: 1.1 }}>✅ Tournament Coaching</motion.li>
              <motion.li whileHover={{ scale: 1.1 }}>✅ Summer Camp Clinics</motion.li>
              <motion.li whileHover={{ scale: 1.1 }}>✅ Video Analysis and Coaching</motion.li>
            </motion.ul>
          </Card.Body>
        </Card>
      </motion.div>
    </Container>
  );
}

export default ServicesCard;
